import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { initialise } from 'app/utils/logger';

import App from './app/App';

if (import.meta.env.PROD) {
  const tagManagerArgs = {
    gtmId: window.CONFIG.gtmId
  };

  TagManager.initialize(tagManagerArgs);
}

if (window.CONFIG.dataDogToken !== undefined) {
  initialise();
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<App />);
